import React from 'react';
import loader from '../../../assets/img/loading.gif';
import Wrapper from './styles';


const SpinnerLoader = () => (
  <Wrapper>
    <div className="loader">
      <img src={loader} alt="Spinner" className="loader-img" />
    </div>
  </Wrapper>
);

export default SpinnerLoader;
